import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import OrderService from "../services/OrderService";

export const OrderContext = createContext("OrderContext");

const OrderContextProvider = ({ children }) => {
	const [orderList, setOrderList] = useState([]);
	const [totalElements, setTotalElements] = useState(0);
	const [loadingOrderList, setLoadingOrderList] = useState(false);
	const [orderListErrorMsg, setOrderListErrorMsg] = useState("");

	const getOrderList = async (params) => {
		setLoadingOrderList(true);
		try {
			setOrderListErrorMsg("");
			const response = await OrderService.getOrdersList(params);
			setOrderList(response.data.content);
			setTotalElements(response.data.totalElements);
			setLoadingOrderList(false);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setOrderListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingOrderList(false);
		}
	};

	return (
		<OrderContext.Provider
			value={{
				getOrderList,
				orderList,
				loadingOrderList,
				orderListErrorMsg,
				totalElements,
			}}
		>
			{children}
		</OrderContext.Provider>
	);
};

export default OrderContextProvider;
